import React, { FC } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { Spin } from "antd";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import moment from "moment";
import HighChartsService from "../../services/highcharts.service";
import CommonService from "../../services/common.service";

const MarketCap: FC = () => {
  const { fetchedData: data, loading } = useHttpGet<{
    result: any;
  }>(`${APIRoutes.CRYPTO_MARKETS_CAPITALIZATION}`, {
    defaultValue: {
      result: [],
    },
  });

  const getOptions = (
    data: any[],
    title: string,
    withBitcoin: boolean = false
  ) => {
    return {
      ...HighChartsService.baseSettings({
        chart: {
          height: 600,
        },
        title: {
          text: title,
        },
        subtitle: {
          text:
            data?.length > 0
              ? `updated on ${moment(data[data?.length - 1]?.updatedOn).format(
                "MM/DD/YYYY HH:mm"
              )}`
              : "",
        },
        legend: {
          enabled: false,
        },
        showRangeSelector: true,
        yAxis: [
          {
            labels: {
              align: "right",
              x: -3,
            },
            title: {
              text: "Market Cap",
            },
            height: "68%",
            lineWidth: 2,
            resize: {
              enabled: true,
            },
          },
          {
            labels: {
              align: "right",
              x: -3,
            },
            title: {
              text: "Volume",
            },
            top: "65%",
            height: "30%",
            offset: 0,
            lineWidth: 2,
          },
        ],
        series: [
          {
            name: "Market Cap",
            data: CommonService.sortByDate(data, "updatedOn")?.map(
              (el: {
                updatedOn: string;
                totalMarketCapilalization: number;
                totalMarketCapilalizationWithoutBitcoin: number;
              }) => [
                  moment(el?.updatedOn).unix() * 1000,
                  withBitcoin
                    ? el?.totalMarketCapilalization
                    : el?.totalMarketCapilalizationWithoutBitcoin,
                ]
            ),
          },
          {
            name: "Volume",
            type: "column",
            yAxis: 1,
            data: CommonService.sortByDate(data, "updatedOn")?.map(
              (el: {
                updatedOn: string;
                total24hVolume: number;
                total24hVolumeWithoutBitcoin: number;
              }) => [
                  moment(el?.updatedOn).unix() * 1000,
                  withBitcoin
                    ? el?.total24hVolume
                    : el?.total24hVolumeWithoutBitcoin,
                ]
            ),
          },
        ],
      }),
    };
  };

  return (
    <Spin spinning={loading}>
      <HighchartsReact
        constructorType={"stockChart"}
        highcharts={Highcharts}
        options={getOptions(
          data?.result,
          "TOTAL MARKET CAPITALIZATION - USD",
          true
        )}
      />
      <HighchartsReact
        constructorType={"stockChart"}
        highcharts={Highcharts}
        options={getOptions(
          data?.result,
          "TOTAL MARKET CAPITALIZATION - USD(Excluding Bitcoin)"
        )}
      />
    </Spin>
  );
};

export default MarketCap;
